import React from "react";

const Facebook = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 h-5"
    >
      <path
        d="M20 10.4737C20 4.97369 15.5 0.473694 10 0.473694C4.5 0.473694 0 4.97369 0 10.4737C0 15.4737 3.625 19.5987 8.375 20.3487V13.3487H5.875V10.4737H8.375V8.22369C8.375 5.72369 9.875 4.34869 12.125 4.34869C13.25 4.34869 14.375 4.59869 14.375 4.59869V7.09869H13.125C11.875 7.09869 11.5 7.84869 11.5 8.59869V10.4737H14.25L13.75 13.3487H11.375V20.4737C16.375 19.7237 20 15.4737 20 10.4737Z"
        fill="#123333"
      />
    </svg>
  );
};

export default Facebook;
